import React from 'react';

function RecurrenceIcon({ width = 20, height = 20, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 20 20">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(1.000000, 0.000000)">
          <g>
            <path d="M18.4997,9.5001 C18.4997,14.4711 14.4707,18.5001 9.4997,18.5001 C4.5287,18.5001 0.4997,14.4711 0.4997,9.5001 C0.4997,4.5291 4.5287,0.5001 9.4997,0.5001 C13.2907,0.5001 16.5337,2.8441 17.8597,6.1601" />
            <path
              d="M18.4997,9.5001 C18.4997,14.4711 14.4707,18.5001 9.4997,18.5001 C4.5287,18.5001 0.4997,14.4711 0.4997,9.5001 C0.4997,4.5291 4.5287,0.5001 9.4997,0.5001 C13.2907,0.5001 16.5337,2.8441 17.8597,6.1601"
              stroke="#000000"
              strokeLinecap="round"
            />
          </g>
          <polyline
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="18.445 2.0987 18.445 6.4207 14.123 6.4207"
          />
        </g>
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default RecurrenceIcon;
